(function () {
	'use strict';

	// ─── Search overlay ─────────────────────────────────────────────────────────
	// The <dialog id="otsing"> printed by includes/search.php. Links to "#otsing"
	// (the header's search icon) open it as a modal, as does a page URL ending in
	// #otsing. Esc, the close button and a click on the backdrop close it.
	// Motion spec: the backdrop fades and the panel rises 16 px over 220 ms
	// (.is-open drives the CSS transitions; reduced motion skips them).
	// Typing shows live results from the arelis_search AJAX action after a short
	// pause; Enter / "Otsi" submits the form to the results page.

	var DURATION = 220;
	var DEBOUNCE = 250;
	var MIN_LENGTH = 2;
	var TRIGGER = 'a[href$="#otsing"]';

	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	var dialog, input, list, count, all, opener, timer, controller, closeTimer;
	var cache = {};

	function el(tag, className, text) {
		var node = document.createElement(tag);
		node.className = className;
		if (text) {
			node.textContent = text;
		}
		return node;
	}

	// ─── Open / close ───────────────────────────────────────────────────────────

	function lockScroll(lock) {
		var root = document.documentElement;
		if (lock) {
			// Keep the layout from shifting when the scrollbar disappears
			root.style.setProperty('--arelis-scrollbar', (window.innerWidth - root.clientWidth) + 'px');
		}
		root.classList.toggle('arelis-search-open', lock);
	}

	function open(trigger) {
		clearTimeout(closeTimer);
		if (dialog.open) {
			dialog.classList.add('is-open');
			return;
		}

		opener = trigger || document.activeElement;
		lockScroll(true);
		dialog.showModal();
		input.focus();
		input.select();
		void dialog.offsetWidth; // start the transition from the closed state
		dialog.classList.add('is-open');
	}

	function close() {
		if (!dialog.open || !dialog.classList.contains('is-open')) {
			return;
		}

		dialog.classList.remove('is-open');
		closeTimer = setTimeout(function () {
			dialog.close();
			lockScroll(false);
			if (opener && typeof opener.focus === 'function') {
				opener.focus();
			}
		}, reducedMotion.matches ? 0 : DURATION);
	}

	// ─── Live results ───────────────────────────────────────────────────────────

	function show(state) {
		dialog.querySelectorAll('[data-search-state]').forEach(function (block) {
			block.hidden = block.getAttribute('data-search-state') !== state;
		});
	}

	function render(data) {
		if (!data.total) {
			show('empty');
			return;
		}

		count.textContent = data.totalLabel;
		list.textContent = '';
		data.items.forEach(function (item) {
			var row = el('li', 'arelis-search__item');
			var link = el('a', 'arelis-search__link', item.title);
			link.href = item.url;
			if (item.external) {
				link.target = '_blank';
				link.rel = 'noopener';
			}
			row.appendChild(el('p', 'arelis-eyebrow', item.label));
			row.appendChild(link);
			list.appendChild(row);
		});
		all.href = data.url;
		all.hidden = data.items.length >= data.total;
		show('results');
	}

	function search(term) {
		if (cache[term]) {
			render(cache[term]);
			return;
		}
		if (controller) {
			controller.abort();
		}
		controller = 'AbortController' in window ? new AbortController() : null;

		var url = window.arelis.ajaxUrl + '?action=arelis_search&s=' + encodeURIComponent(term);
		dialog.classList.add('is-loading');
		fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
			.then(function (response) {
				return response.json();
			})
			.then(function (json) {
				if (!json || !json.success) {
					throw new Error('search failed');
				}
				cache[term] = json.data;
				if (input.value.trim() === term) {
					render(json.data);
				}
				dialog.classList.remove('is-loading');
			})
			.catch(function (error) {
				if (error.name !== 'AbortError') {
					dialog.classList.remove('is-loading');
				}
			});
	}

	function onInput() {
		clearTimeout(timer);
		var term = input.value.trim();
		if (term.length < MIN_LENGTH) {
			if (controller) {
				controller.abort();
			}
			dialog.classList.remove('is-loading');
			show('default');
			return;
		}
		timer = setTimeout(function () {
			search(term);
		}, DEBOUNCE);
	}

	// ─── Wiring ─────────────────────────────────────────────────────────────────

	function prepareTrigger(trigger) {
		trigger.setAttribute('role', 'button');
		trigger.setAttribute('aria-haspopup', 'dialog');
		trigger.setAttribute('aria-controls', 'otsing');
		if (!trigger.getAttribute('aria-label') && !trigger.textContent.trim()) {
			trigger.setAttribute('aria-label', dialog.querySelector('.arelis-search__title').textContent);
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		dialog = document.getElementById('otsing');
		if (!dialog || typeof dialog.showModal !== 'function') {
			return;
		}

		input = dialog.querySelector('.arelis-search-form__input');
		list = dialog.querySelector('[data-search-list]');
		count = dialog.querySelector('[data-search-count]');
		all = dialog.querySelector('[data-search-all]');

		document.querySelectorAll(TRIGGER).forEach(prepareTrigger);

		document.addEventListener('click', function (event) {
			var trigger = event.target.closest(TRIGGER);
			if (trigger) {
				event.preventDefault();
				open(trigger);
			}
		});

		// role="button" links also open with Space
		document.addEventListener('keydown', function (event) {
			if (event.key === ' ' && event.target.matches && event.target.matches(TRIGGER)) {
				event.preventDefault();
				open(event.target);
			}
		});

		dialog.querySelector('.arelis-search__close').addEventListener('click', close);

		// The dialog fills the viewport; a click outside the panel is the backdrop
		dialog.addEventListener('click', function (event) {
			if (event.target === dialog) {
				close();
			}
		});

		// Esc: animate out instead of the instant native close. Handled on keydown
		// too, because Esc in a filled search field only clears it natively.
		dialog.addEventListener('cancel', function (event) {
			event.preventDefault();
			close();
		});
		dialog.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				event.preventDefault();
				close();
			}
		});

		input.addEventListener('input', onInput);

		if (window.location.hash === '#otsing') {
			open(null);
		}
	});

})();
